var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrEnd"},[_c('p',{staticClass:"ln3"},[_vm._v("К сожалению компания отказала вам в выдаче займа, повторное обращение возможно через 1 месяц.")])])
}]

export { render, staticRenderFns }